import { render, staticRenderFns } from "./UserIdentifiers.vue?vue&type=template&id=443e022b"
import script from "./UserIdentifiers.vue?vue&type=script&lang=ts"
export * from "./UserIdentifiers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports